import React from 'react';
import Paper from '@material-ui/core/Paper';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    maxWidth: 520,
    margin: '40px auto',
    padding: '20px 24px',
    border: '1px solid #EAEEF5',
    color: '#5B6472',
    fontSize: 15,
  },
  icon: { color: '#8A94A6' },
}));

// Shown on a list page when the signed-in role has no "view" permission.
export default function NoAccess({ what, permissionLoaded = true }) {
  const classes = useStyles();
  if (!permissionLoaded) return null;
  return (
    <Paper className={classes.card}>
      <LockOutlinedIcon className={classes.icon} />
      <span>{`Your role does not have permission to view ${what}.`}</span>
    </Paper>
  );
}
